import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import Box from 'features/Hotel/Box'
import { useState } from 'react'

import styles from './HostedMessaging.module.scss'

const HostedMessaging = ({
  fullName,
  status,
  reEnableRegistery,
  isDialogVisible,
  setDialogVisible,
  phoneNumbers
}) => {
  const [authorizingParty, setAuthorizingParty] = useState('')
  const hasActivePhoneNumber = phoneNumbers.some(
    phoneNumber => phoneNumber.status === 'Active'
  )
  const shouldBeEditable = hasActivePhoneNumber

  function handleSendAuthorizingParty() {
    setDialogVisible(false)
    reEnableRegistery({ HostMessagingAuthorizingPartyFullName: authorizingParty })
  }

  return (
    <div className={styles.wrapper}>
      <Box title="Hosted messaging">
        <div className={styles.container}>
          {shouldBeEditable && (
            <button className={styles.editButton} onClick={() => setDialogVisible(true)}>
              Edit
            </button>
          )}
          <span
            style={{
              color: status === 'Enabled' ? '#66bb6a' : 'rgb(190 187 187)',
              fontWeight: 500
            }}
          >
            {shouldBeEditable
              ? status
              : 'Purchase a phone number to set up hosted messaging'}
          </span>
          {shouldBeEditable && fullName && <> with name {fullName}</>}
        </div>
      </Box>
      {isDialogVisible && (
        <ConfirmationDialog
          title="Set hosted messaging"
          negativeMessage="Cancel"
          positiveMessage="Enable hosted messaging"
          onReject={() => setDialogVisible(false)}
          onConfirm={handleSendAuthorizingParty}
          isButtonDisabled={authorizingParty.length < 2}
          theme="blacklist"
        >
          <TextInput
            className={styles.input}
            label="Full name of authorized party"
            value={authorizingParty}
            onChange={e => setAuthorizingParty(e.target.value)}
          />
        </ConfirmationDialog>
      )}
    </div>
  )
}

export default HostedMessaging
